import { Component, createRef } from "react";
import { BillWatchProps } from "../BillWatchProps";
import { BillWatchLayout } from '../BillWatchLayout';
import { BillWatchEntities } from "../BillWatchEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSCCostChart } from "namirasoft-cost-react";
import RunDialogBox from "../components/RunDialogBox";

interface GCPListPageProps extends NSARouterMakerResult, BillWatchProps { }

export default class GCPListPage extends Component<GCPListPageProps>
{
    BillWatchLayout_Ref = createRef<BillWatchLayout>();
    RunDialogBox_Ref = createRef<RunDialogBox>();

    override render()
    {
        return (
            <BillWatchLayout
                ref={this.BillWatchLayout_Ref}
                {...this.props}
                action={{
                    description: "You can view all your previously created GCP watches in this section.",
                    menus: {}
                }}
                pages={{
                    entity: BillWatchEntities.gcp(this.props, (id) => this.RunDialogBox_Ref.current?.show(id)),
                    list: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_history: [
                                            NSCCostChart.getTab(this.props)
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <RunDialogBox
                    {...this.props}
                    ref={this.RunDialogBox_Ref}
                    set_next_run={this.props.servers.bill_watch.gcp.SetNextRun}
                    reload={() =>
                    {
                        this.BillWatchLayout_Ref.current
                            ?.NSALayout_Ref.current
                            ?.NSASectionList_Ref.current
                            ?.NSATable_Main.current
                            ?.NSTable_Main.current
                            ?.reload(null, null);
                    }}
                />
            </BillWatchLayout>
        );
    }
}